import React, { useState, useEffect, useRef } from "react"
import {
  Row,
  Col,
  Card,
  CardBody,
  Input,
  Table,
  Button,
  Modal,
} from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import ReactPaginate from "react-paginate"
import { Toaster } from "react-hot-toast"
import { addData } from "Servicescalls"
import { useReactToPrint } from "react-to-print"
import logo from "../../../assets/images/logo.png"

const Users = () => {
  const componentRef = useRef()

  const [User, setUser] = useState([])
  const [fromDate, setFromDate] = useState("")
  const [toDate, setToDate] = useState("")
  const [modal_small2, setmodal_small2] = useState(false)

  const [products, setproducts] = useState([])
  const [products1, setproducts1] = useState([])
  const [form, setform] = useState({
    name: "",
    phone: "",
    customvalue: false,
    posType: "pos",
    deliveryBoyId: "",
    address: "",
  })
  const [form2, setform2] = useState({ couponAmount: "" })
  const [forminfo, setforminfo] = useState([])

  const [invoice, setinvoice] = useState({
    username: "",
    userPhone: "",
    bookingId: "",
    subTotal: 0,
    sgst: 0,
    cgst: 0,
    discount: 0,
    totalPrice: 0,
    paymentMethod: "",
  })

  useEffect(() => {
    GetAll()
  }, [])

  const GetAll = async () => {
    const dataArray = { paymentStatus: "All" }
    const resonse = await addData("customer/getAllPaymentsAndOrders", dataArray)
    setUser(resonse?.data?.orders || [])
  }

  const [listPerPage] = useState(5)
  const [pageNumber, setPageNumber] = useState(0)

  const pagesVisited = pageNumber * listPerPage

  const filteredData = User.filter(item => {
    const d = item?.logCreatedDate ? item.logCreatedDate.slice(0, 10) : ""
    if (fromDate && d < fromDate) return false
    if (toDate && d > toDate) return false
    return true
  })

  const lists = filteredData.slice(pagesVisited, pagesVisited + listPerPage)
  const pageCount = Math.ceil(filteredData.length / listPerPage)

  const changePage = ({ selected }) => {
    setPageNumber(selected)
  }

  const [search, setsearch] = useState({})

  const searchAll = async e => {
    let myUser = { ...search }
    myUser[e.target.name] = e.target.value
    setsearch(myUser)

    const dataArray = { paymentStatus: "All" }
    const resonse = await addData(
      "customer/getAllPaymentsAndOrders?searchQuery=" + e.target.value,
      dataArray
    )
    setUser(resonse?.data?.orders || [])
    setPageNumber(0)
  }

  const downloadCSV = () => {
    if (!filteredData.length) return

    const exportRows = filteredData.map((data, idx) => ({
      SlNo: idx + 1,
      Date: data.logCreatedDate?.slice(0, 10) || "",
      BookingId: data.bookingId || "",
      UserId: data.userId || "",
      UserName: data.name || "",
      Email: data.email || "",
      Phone: data.phone || "",
      Items: Array.isArray(data.items)
        ? data.items.map((it, i) => `${i + 1})${it.dishName || ""}`).join(" | ")
        : "",
         SubTotal: data.subTotal || "",
      CGST: data.cgst || "",
      SGST: data.sgst || "",
      TotalAmount: data.totalPrice || "",
      PaymentType: data.paymentMethod || "",
      TransactionId: data.transactionId || "",
      Status: data.paymentStatus || "",
    }))

    const headers = Object.keys(exportRows[0])
    const csv = [
      headers.join(","),
      ...exportRows.map(row =>
        headers.map(h => `"${String(row[h]).replace(/"/g, '""')}"`).join(",")
      ),
    ].join("\n")

    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" })
    const link = document.createElement("a")
    link.href = URL.createObjectURL(blob)
    link.download = "booking_report.csv"
    link.click()
  }

  function tog_small2() {
    setmodal_small2(!modal_small2)
  }

  const modalclose = () => {
    setmodal_small2(false)
    setproducts([])
    setproducts1([])
    setform({
      name: "",
      phone: "",
      customvalue: false,
      posType: "pos",
      deliveryBoyId: "",
      address: "",
    })
    setform2({ couponAmount: "" })
    setforminfo([])
  }

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  })

  const printsecctions = () => {
    setTimeout(() => {
      handlePrint()
      modalclose()
    }, 300)
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs
            title="Hasini Enterprises"
            breadcrumbItem="Booking Report"
          />

          <Row>
            <Col>
              <Card>
                <CardBody>
                  <Row>
                    <Col>
                      <Row className="g-2">
                        <Col md={4}>
                          <Input
                            type="date"
                            className="form-control"
                            value={fromDate}
                            onChange={e => {
                              setFromDate(e.target.value)
                              setPageNumber(0)
                            }}
                          />
                        </Col>
                        <Col md={4}>
                          <Input
                            type="date"
                            className="form-control"
                            value={toDate}
                            onChange={e => {
                              setToDate(e.target.value)
                              setPageNumber(0)
                            }}
                          />
                        </Col>
                        <Col md={4} className="d-flex justify-content-end">
                          <button
                            className="btn btn-primary"
                            onClick={downloadCSV}
                          >
                            Download CSV
                          </button>
                        </Col>
                      </Row>
                    </Col>
                    <Col>
                      <div style={{ float: "right" }}>
                        <Input
                          type="search"
                          className="form-control"
                          placeholder="Search.."
                          value={search.search || ""}
                          onChange={searchAll}
                          name="search"
                        />
                      </div>
                    </Col>
                  </Row>

                  <div className="table-rep-plugin mt-4">
                    <Table hover bordered responsive>
                      <thead>
                        <tr>
                          <th>Sl.No</th>
                          <th>Date</th>
                          <th>Booking Id</th>
                          <th>User Id</th>
                          <th>User Name</th>
                          <th>Email</th>
                          <th>Phone</th>
                          <th>Items</th>
                          <th>Total Amount</th>
                          <th>Payment Type</th>
                          <th>Transaction Id</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {lists.map((data, key) => (
                          <tr key={key}>
                            <th scope="row">{pagesVisited + key + 1}</th>
                            <td>{data.logCreatedDate?.slice(0, 10)}</td>
                            <td>{data.bookingId}</td>
                            <td>{data.userId}</td>
                            <td>{data.name}</td>
                            <td>{data.email}</td>
                            <td>{data.phone}</td>
                            <td>
                              {data.items?.map((datas, i) => (
                                <p key={i}>
                                  {i + 1}){datas.dishName}
                                </p>
                              ))}
                            </td>
                            <td>{data.totalPrice}</td>
                            <td>{data.paymentMethod}</td>
                            <td>{data.transactionId}</td>
                            <td>
                              <span className="badge bg-primary">
                                {data.paymentStatus}
                              </span>
                            </td>
                            <td>
                              <Button
                                className="mt-3 btn-sm"
                                onClick={() => {
                                  setmodal_small2(true)
                                  setinvoice({
                                    username: data.name,
                                    userPhone: data.phone,
                                    bookingId: data.bookingId,
                                    subTotal: data.subTotal || 0,
                                    sgst: data.sgst || 0,
                                    cgst: data.cgst || 0,
                                    discount: data.discount || 0,
                                    totalPrice: data.totalPrice,
                                    paymentMethod: data.paymentMethod,
                                  })
                                  setproducts1(data.items || [])
                                }}
                              >
                                Print
                              </Button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>

                    <Col sm="12">
                      <div
                        className="d-flex mt-3 mb-1"
                        style={{ float: "right" }}
                      >
                        <ReactPaginate
                          previousLabel={"Previous"}
                          nextLabel={"Next"}
                          pageCount={pageCount}
                          onPageChange={changePage}
                          containerClassName={"pagination"}
                          activeClassName={"active"}
                        />
                      </div>
                    </Col>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>

        <Toaster />

        <Modal isOpen={modal_small2} toggle={tog_small2} centered>
          <div className="modal-body">
            <Button color="success" onClick={printsecctions}>
              Proceed If thermal printer is ready
            </Button>
            <Button color="danger" onClick={modalclose} className="ms-2">
              Cancel
            </Button>

            <Row>
              <Col md="2"></Col>
              <Col md="8">
                <div ref={componentRef}>
                  <div className="modal-body">
                    <div id="printableArea">
                      <div className="initial-38-1">
                        <div className="text-center mb-3">
                          <img src={logo} />
                        </div>
                        <div className="text-center">
                          <h5
                            style={{ fontSize: "12px" }}
                            className="text-break initial-38-4"
                          >
                            Name : {invoice.username}
                          </h5>
                          <h5
                            style={{ fontSize: "12px" }}
                            className="initial-38-4 initial-38-3"
                          >
                            Phone : {invoice.userPhone}
                          </h5>
                        </div>
                        <div
                          style={{ borderBottom: "2px dashed #000" }}
                          className="initial-38-5"
                        ></div>
                        <div className="row mt-1">
                          <div className="col-5 pl-1 ml-1 pr-0 mr-0">
                            <h5 style={{ fontSize: "12px", fontWeight: "800" }}>
                              Invoice ID:
                              <span
                                style={{ marginBottom: "0px" }}
                                className="font-light"
                              >
                                {" "}
                                {invoice.bookingId}
                              </span>
                            </h5>
                          </div>
                          <div className="col-7 pl-1 ml-1 pr-0 mr-0">
                            <h5 style={{ fontSize: "12px", fontWeight: "800" }}>
                              <span className="font-light">
                                GST.No: 36ALXPB9886D2ZE
                                {/* {invoice?.updatedAt.slice(0, 10)} - {invoice?.updatedAt.slice(11, 15)} */}
                              </span>
                            </h5>
                          </div>
                          <div className="col-12"></div>
                        </div>
                        <h5
                          style={{ margin: "0px" }}
                          className="text-uppercase"
                        />
                        <span
                          style={{ borderBottom: "2px dashed #000" }}
                          className="initial-38-5"
                        ></span>
                        <table
                          style={{
                            fontSize: "10px",
                            marginBottom: "7px",
                            border: "2px solid black",
                          }}
                          className="table table-bordered"
                        >
                          <thead>
                            <tr>
                              <th
                                style={{ padding: "5px" }}
                                className="initial-38-6 border-top-0 border-bottom-0"
                              >
                                SNo
                              </th>
                              <th
                                style={{ padding: "5px" }}
                                className="initial-38-7 border-top-0 border-bottom-0"
                              >
                                Description
                              </th>
                              <th
                                style={{ padding: "5px" }}
                                className="initial-38-7 border-top-0 border-bottom-0"
                              >
                                Price
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {products1.map((data, key) => (
                              <tr key={key}>
                                <td style={{ padding: "5px" }}>{key + 1}</td>
                                <td style={{ padding: "5px" }}>
                                  <div>
                                    <h5 style={{ fontSize: "12px" }}>
                                      <b>
                                        {data.quantity} - {data.dishName}
                                      </b>
                                    </h5>
                                    {/* <b>Qty :</b> <span><b></b></span>
                                    <br />
                                    <b>Unit Price :</b>
                                    <span> <b>₹ {data.amount}</b></span>
                                    <br /> */}
                                  </div>
                                </td>
                                <td
                                  style={{ padding: "5px" }}
                                  className="w-28p"
                                >
                                  {" "}
                                  <b>₹ {data.amount * data.quantity}</b>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>

                        <div className="px-3">
                          <dl
                            style={{ margin: "0px" }}
                            className="row text-right justify-content-center"
                          >
                            <dt style={{ margin: "0px" }} className="col-6">
                              Subtotal :
                            </dt>
                            <dd style={{ margin: "0px" }} className="col-6">
                              ₹ {invoice.subTotal}
                            </dd>

                            <dt style={{ margin: "0px" }} className="col-6">
                              SGST :
                            </dt>
                            <dd style={{ margin: "0px" }} className="col-6">
                              ₹
                              {invoice.sgst == undefined || invoice.sgst == null
                                ? 0
                                : invoice.sgst}
                            </dd>
                            <dt style={{ margin: "0px" }} className="col-6">
                              CGST :
                            </dt>

                            <dd style={{ margin: "0px" }} className="col-6">
                              ₹
                              {invoice.cgst == undefined || invoice.cgst == null
                                ? 0
                                : invoice.cgst}
                            </dd>
                            <dt style={{ margin: "0px" }} className="col-6">
                              Discount :
                            </dt>
                            <dd style={{ margin: "0px" }} className="col-6">
                              ₹{" "}
                              {invoice.couponAmount == "NaN"
                                ? 0
                                : invoice.discount}{" "}
                              <hr
                                style={{
                                  marginBottom: "5px",
                                  marginTop: "5px",
                                }}
                              />
                            </dd>

                            <dt className="col-6 font-20px">Total:</dt>
                            <dd className="col-6 font-20px">
                              ₹ {invoice.totalPrice}
                            </dd>
                            <dt className="col-6 font-20px">Money Type:</dt>
                            <dd className="col-6 font-20px">
                              {invoice.paymentMethod}
                            </dd>
                          </dl>

                          <div
                            style={{ borderBottom: "2px dashed #000" }}
                            className="initial-38-5"
                          ></div>
                          <h5
                            style={{ fontWeight: "800" }}
                            className="text-center"
                          >
                            <span className="d-block pt-2">
                              """THANK YOU"""
                            </span>
                          </h5>
                          <div
                            style={{ borderBottom: "2px dashed #000" }}
                            className="initial-38-5"
                          ></div>
                          <span className="d-block text-center text-mute pt-2">
                            Copyright @ Hasini Enterprises
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col md="2"></Col>
            </Row>
          </div>
        </Modal>
      </div>
    </React.Fragment>
  )
}

export default Users
